<template>
  <KikForm
    :text-area="mgnlProps.form1"
    :title-area="mgnlProps.form2"
    :terms-conditions-area="mgnlProps.form3"
    :btn-label="mgnlProps.btnLabel"
    :side-by-side="mgnlProps.sideBySide"
    :subject-options="mgnlProps.subjectOptions"
    :salutation-options="mgnlProps.salutationOptions"
  />
</template>

<script lang="ts" setup>
import { WrapperProps, FormBuilder } from './Form.model';
import KikForm from '~/components/Shared/Forms/Form/Form.vue';

const props = defineProps(WrapperProps);
const mgnlProps = computed(() => FormBuilder.build(props));
</script>
